import { render } from "./ScorecardTemplate.vue?vue&type=template&id=73c48712"
import script from "./ScorecardTemplate.vue?vue&type=script&lang=js"
export * from "./ScorecardTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/ScorecardTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73c48712"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73c48712', __exports__)) {
    api.reload('73c48712', __exports__)
  }
  
  module.hot.accept("./ScorecardTemplate.vue?vue&type=template&id=73c48712", () => {
    api.rerender('73c48712', render)
  })

}


export default __exports__